import { Skeleton } from "@roberttamas/ui";
import { Navigate, Outlet } from "react-router-dom";

import { useIsAdmin } from "@/lib/permissions";

/**
 * Gate for admin-only routes, nested inside the shared authenticated shell
 * (no layout of its own — `AppShell` already renders around this). Buyers
 * (confirmed via a `permission-denied` on `listSites`) land here via the
 * default post-login "/sites" and are forwarded to their orders instead of
 * a dead-end "no access" wall.
 */
export function AdminRoute() {
  const { isAdmin, isLoading } = useIsAdmin();

  // First-time gate fetch: a small in-content placeholder instead of a
  // full-viewport loader, since this now renders inside the shell's content
  // area rather than in place of the whole page.
  if (isLoading) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-10 w-72" />
        <Skeleton className="h-80 w-full" />
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/my-orders" replace />;
  }

  return <Outlet />;
}
